import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/auth.context";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-reveal";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.Fragment>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.Fragment>
  </BrowserRouter>
);
